<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" v-if="qx.update"  -->
		<div>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" :optional="editops" :useAutoOptional="false"
				opwidth="72px" top="377px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.revoke" backgroundColor="#FFF" title="弃审" fontSize="14px" @btnclick="UNshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Expost"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.update" backgroundColor="#FFF" title="入库单导入" fontSize="14px" @getFile="rkImport"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" title="指导视频" fontSize="14px" @btnclick="GuidanceVideo"
				:src="require('@/assets/icon/video.png')">
			</Commonbtn>
			<a v-if="qx.update"
				style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
				@click="dowload">下载入库单导入模版</a>
		</div>
		<!-- style="border: 1px solid blue;" -->

		<div class="TableWidth">
			<Commontable ref="WareHousingRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="CusTypeFlag == 1 ? headerData : headerDatatow" height="100%"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom :OKASCAN="false" width="1000px" title="编辑入库单" :dialogVisible="dialogVisiblesedit"
			@cancel="canceledit" @dialogOK="dialogOKedit">
			<Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" @btnclick="seve"
				:src="require('@/assets/icon/bc.png')">
			</Commonbtn>
			<div v-if="type == 1">
				<!-- <Commonbtn backgroundColor="#FFF" title="导出入库唯一码" fontSize="14px" @btnclick="ExpostUnique" :src="require('@/assets/icon/daoc.png')">
        </Commonbtn> -->
			</div>

			<div class="inputtop" style="width: 940px !important;">
				<template v-for="(item , index) of formdatadeit">
					<Commondropdownlist ref="editRd" :event="item.event" @invClass="invClass" :disabled="item.disabled"
						:key="index+'listTop'" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width">
					</Commondropdownlist>
				</template>
			</div>
			<div>
				<Commonbtn v-if="wtype == 0 && tableflag || wtype == 1 && tableflags " :optional="statusDel"
					opwidth="114px" top="269px" backgroundColor="#FFF" title="删除选中项" fontSize="14px"
					@btnclick="delSelected " :src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<div style="margin-left: 10px;">
					<!-- <Commonbtn title="导出"></Commonbtn> -->
					<div class="topstate" v-for="(item , index) of state" :key="index+'title'"
						:class="[{ 'ativte' : onchage == index}]" @click="tabClick(index)">
						{{ item.title }}
					</div>
				</div>
				<!-- style="border: 1px solid blue;" -->
				<div v-if="tableflag" style="overflow-x: scroll;">
					<Commontable ref="Ta56" :loadingTable="false" class="EditDom"
						@handleSelectionChange="handleSelectionChangedialog" :wtype="wtype" :tableflag="tableflag"
						colnum=56 :tableData="tableDataDis" :headerData="headerDatas" height="100%" v-if="wtype == 1">
					</Commontable>
					<Commontable ref="Ta57" :loadingTable="false" class="EditDom"
						@handleSelectionChange="handleSelectionChangedialog" :wtype="wtype" :tableflag="tableflag"
						colnum=57 :tableData="tableDataDis" :headerData="headerDatas" height="100%" v-if="wtype == 0">
					</Commontable>
				</div>
				<div width="1000px" v-if="tableflags">
					<Commontable class="EditDom" :loadingTable="false"
						@handleSelectionChange="handleSelectionChangedialogUnique" :wtype="wtype"
						:tableflags="tableflags" :tableflag="tableflag" width="1000px" colnum=57
						:tableData="tableDataUnique" :headerData="headerDataUni" height="100%"></Commontable>
					<!-- <Commontable @handleSelectionChange="handleSelectionChangedialogUnique" :wtype="wtype" :tableflag="tableflag" width="1000px" colnum=57 :tableData="tableDataUnique" :headerData="headerDataUni" height="100%" ></Commontable> -->
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="入库上报管理指导视频" :OKASCAN="false" :dialogVisible="dialogVisibGuidanceVideo"
			@cancel="cancelGuidanceVideo" @dialogOK="dialogOKGuidanceVideo">
			<VideoPlayer ref="wareVideo" :srcVideo="require('../../../../assets/video/ware/ware.mp4')">
			</VideoPlayer>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg"
					:headerData="headerData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除吗？</span>
		</Dialog>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqUNshen" @cancel="cancelqUNshen"
			@dialogOK="dialogOKqUNshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审吗？</span>
		</Dialog>

	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import Dialog from '../../../../components/dialog.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import tb from '../fromData/tb'
	import headerDatas from '../table/headerDatas'
	import headerData from '../table/headerData'
	import headerDatatow from '../table/headerDatatow'
	import headerDataUni from '../table/headerDataUni'
	import newtb from '../fromData/newtb'
	import utils from '../../../../common/utils'
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import {
		AsnInfo,
		InventoryClassList,
		ASNVoucherType,
		Import,
		DownloadTemplet,
		AsnDelete,
		AsnVerify,
		AsnUnVerify,
		UniqueExportForEdit,
		ASNEdit,
		InventoryClassInfo,
		AsnDetail,
		AsnUnique,
		CusType
	} from '@/api/home'
	import fromdata from '../../../basicarchivesmanagement/businesshospitalrelationship/fromData/add'
	import VideoPlayer from '../../../../components/videoPlayer.vue'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			Dialog,
			DialogFrom,
			Commondropdownlist,
			CommonbtnUpLoad,
			VideoPlayer
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			},
			type: {
				type: Number,
				default: 0
			},

		},
		data: function() {
			return {
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisiblestb: false,
				dialogVisiblesedit: false,
				dialogVisiblesdrjg: false,
				dialogVisibledel: false,
				dialogVisibleqUNshen: false,
				dialogVisibGuidanceVideo: false,
				statusDel: true,
				tableflag: true,
				tableflags: false,
				editops: true,
				IsBarCodeControl: -1,
				ASNMID: "",
				CusTypeFlag: 0,
				rowboo: false,
				tableDatadrjg: [],
				handleData: [],
				tableDataUnique: [],
				tableDataDis: [],
				TableDialogUniqueData: [],
				downURL: '',
				onchage: 0,
				title: '导入结果',
				headerData: [],
				headerDatas: [],
				headerDatatow: [],
				formdatadeit: [{
						inputdata: '',
						title: '入库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '70px',
						disabled: true
					},
					{
						inputdata: '',
						title: '创建日期',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'dates',
						width: '210px',
						lablewith: '70px',
						disabled: true
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						btx: true,
						lablewith: '70px',
						options: [],
						disabled: true,
						event: "invClass",
					},
					{

						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						btx: true,
						lablewith: '70px',
						options: [],
						disabled: true
					},
					{
						inputdata: '',
						title: '备注',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '500px',
						lablewith: '70px'
					},
				],
				tbfromdata: [],
				tbnewfromdata: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					revoke: false,
					skip: false, //跳过
					reset: false, //重置
				},

				from: {
					VoucherType: "",
					InvClass: "",
					VouCode: "",
					Remark: ""
				},
				TableDialogData: [],
				state: [],
				wtype: null,

			}
		},
		mounted() {
			this.tbfromdata = JSON.parse(JSON.stringify(tb))
			this.tbnewfromdata = JSON.parse(JSON.stringify(newtb))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDatas = JSON.parse(JSON.stringify(headerDatas))
			this.headerDatatow = JSON.parse(JSON.stringify(headerDatatow))
			this.headerDataUni = JSON.parse(JSON.stringify(headerDataUni))
			// this.$store.dispatch("CUS_TYPE")
			this.cusType()
			// setTimeout(()=>{
			//   //console.log(this.$store.state.CusTypeFlag,'CusTypeFlag');
			//   this.CusTypeFlag = this.$store.state.CusTypeFlag
			//   loading.close();
			// },500)
			this.butQ()
		},
		methods: {
			// 按钮权限
			butQ() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				//console.log(data, "data");
				data.Menus.map((item, index) => {
					if (item.NodeID == 18) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 19) {
								this.qus = items.Nodes
							}
						})
					}
				})
				//console.log(this.qus, 'qus');
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'revoke') {
							this.qx.revoke = true
						}
					})
				}
			},
			async cusType() {
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				if (code == 0) {
					if (data.CusType == "") {
						this.CusTypeFlag = 1
					} else if (data.CusType == "平台") {
						this.CusTypeFlag = 2
					} else {
						this.CusTypeFlag = 3
					}
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdatadeit[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdatadeit[3].options.push(obj)
					})

				}

			},
			// 详情
			async AsnInfo() {
				let {
					code,
					data
				} = await AsnInfo({
					asnmid: this.ASNMID
				})
				if (code == 0) {
					// //console.log(this.$refs.editRd,'this.$refs.editRd');
					this.$refs.editRd[4].modelvalue = data.Remark
					this.$refs.editRd[1].modelvalue = data.CreateTime
					this.$refs.editRd[2].modelvalue = data.InvClass
					this.$refs.editRd[3].modelvalue = data.VoucherType
					this.$refs.editRd[0].modelvalue = data.VouCode

					this.tableDataUnique = data.UniqueOutPutList
					this.inventoryClassInfo(data.InvClass)
					this.tableDataDis = data.DetailList
					if (this.$refs.editRd[3].modelvalue == '采购入库' || this.formdatadeit[3].modelvalue == '采购退货') {
						this.statusDel = true
						//  data.DetailList.map((item , index) => {
						//   this.$set(item , 'disabled' , true)
						//  })
					} else {
						this.statusDel = false
					}
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdatadeit[2].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdatadeit[2].options.push(obj)
					})
				}
			},
			// 删除
			async asnDelete() {
				let idArr = []
				this.handleData.map((item, index) => {
					idArr.push(item.ASNMID)
				})
				let {
					code,
					message,
					data
				} = await AsnDelete({
					asnmiDs: idArr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功！'
					});
					this.$parent.asnList()
					this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "删除结果"
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 弃审
			async asnUnVerify() {
				let idArr = []
				this.handleData.map((item, index) => {
					idArr.push(item.ASNMID)
				})
				let {
					code,
					message,
					data
				} = await AsnUnVerify({
					asnmiDs: idArr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功！'
					});
					this.$parent.asnList()
					this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "弃审结果"
					this.$message({
						type: 'error',
						message: message
					});
				}

			},
			// 审核
			async asnVerify(que = false) {
				let idArr = []
				this.handleData.map((item, index) => {
					idArr.push(item.ASNMID)
				})
				let params = {
					asnmiDs: idArr
				}
				if (que) {
					params.NoNeedCheckInventoryProvince = 1;
				}
				let {
					code,
					message,
					data
				} = await AsnVerify(params)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功！'
					});
					this.handleData = [];
					this.$parent.asnList()
					this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 300) {
					this.$confirm(`<strong>${message}</strong><br/>${data.join(',<br/>')}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						this.asnVerify(true);
					}).catch(() => {});
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "审核结果"
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 明细保存
			async aSNEditmx() {
				let {
					code,
					message
				} = await ASNEdit({
					ASNMID: this.ASNMID,
					Remark: this.from.Remark,
					DetailList: this.tableDataDis
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					this.dialogVisiblesedit = false
					this.$parent.asnList()
					this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 唯一码保存
			async aSNEditUnoq() {
				let arr = this.tableDataUnique.map(item => item.ID)
				//console.log(arr, 'arr');
				let {
					code,
					message
				} = await ASNEdit({
					ASNMID: this.ASNMID,
					VoucherType: this.from.VoucherType,
					InvClass: this.from.InvClass,
					VouCode: this.from.VouCode,
					Remark: this.from.Remark,
					DetailList: this.tableDataDis,
					DetailUniqueList: arr
				})
				switch (code) {
					case 0:
						this.$message({
							type: 'success',
							message: message
						});
						this.dialogVisiblesedit = false
						this.$parent.asnList()
						this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection()
						break;
					case 101:
						this.$message({
							type: 'warning',
							message: message
						});
						break;
					default:
						this.$message({
							type: 'error',
							message: message
						});
						break;
				}
			},
			// 导出
			Expost() {
				this.$emit('Expost')
			},
			//入库唯一码导出 
			async expostUniqueEdit() {
				let resexprot = await UniqueExportForEdit({})
				if (resexprot) {

					// 切割出文件名
					// const fileNameEncode = resexprot.headers.get('content-disposition').split('filename=')[1]
					// // 解码
					// const fileName = decodeURIComponent(fileNameEncode)
					//console.log(resexprot.headers);
					// //console.log('fileName', fileName)

					utils.downloadFile(resexprot.data, `库唯一码导出${new Date().getTime()}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			ExpostUnique() {
				this.expostUniqueEdit()
			},
			// 导入
			async rkImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await Import(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					this.$parent.asnList()
					loading.close();
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
				} else if (code == 1) {
					this.$message({
						type: 'warning',
						message: message
					});
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "导入结果"
					this.$parent.asnList()
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = "导入结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 下载模板
			async dowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"

				let {
					data,
					code,
					message
				} = await DownloadTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				//console.log("下载");

			},
			invClass(e) {
				this.inventoryClassInfo(e.modelvalue)
			},
			// 判断是否开启唯一码
			async inventoryClassInfo(invClass) {
				let {
					code,
					data
				} = await InventoryClassInfo({
					invClass: invClass
				})
				if (code == 0) {
					this.wtype = data.IsBarCodeControl
					if (data.IsBarCodeControl == 1) {
						let arr = [{
								title: '明细'
							},
							{
								title: '唯一码'
							}
						]
						this.state = arr
					} else if (data.IsBarCodeControl == 0) {
						let arr = [{
							title: '明细'
						}]
						this.state = arr
					}
				}
			},
			// 唯一码明细
			async asnUnique() {
				let {
					data,
					code
				} = await AsnUnique({
					asnmid: this.ASNMID
				})
				if (code == 0) {
					this.tableDataUnique = data
				}
			},
			// 明细
			async asnDetail() {
				let {
					data,
					code
				} = await AsnDetail({
					asnmid: this.ASNMID
				})
				if (code == 0) {
					this.tableDataDis = []
					this.tableDataDis = data
				}
			},
			update() {
				if (this.handleData.length === 1 && this.editops === false) {
					this.ASNMID = this.handleData[0].ASNMID
					this.rowboo = true
					this.asnDetail()
					this.AsnInfo()
					this.inventoryClassList()
					this.aSNVoucherType()
					this.dialogVisiblesedit = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});
			},
			tabClick(index) {
				if (index == 0) {
					this.tableflag = true
					this.tableflags = false
					// if (this.dialogindex == "update") {
					// this.asnDetail()
					// }
				}
				if (index == 1) {
					this.tableflag = false
					this.tableflags = true
					// if (this.dialogindex == "update") {
					// this.asnUnique()
					// }
				}
				if (this.onchage != index) {
					this.onchage = index
				}
			},
			handleSelectionChangedialog(val) {
				this.TableDialogData = val
			},
			handleSelectionChangedialogUnique(val) {
				this.TableDialogUniqueData = val
			},
			handleSelectionChange(val) {
				this.handleData = val
				if (val.length === 1) {
					this.rowboo = true
					this.ASNMID = val[0].ASNMID
					this.editops = val[0].Status == 0 ? false : true
					return
				}
				this.rowboo = false
				this.editops = true
				if (val.length === 0) {
					this.ASNMID = ""
				}
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			onRowClick(val) {
				// 不要在这里覆盖全局多选算出来的 editops，直接取最新的 handleData 计算
				if (this.handleData && this.handleData.length === 1) {
					this.rowboo = true
					this.ASNMID = this.handleData[0].ASNMID
					this.editops = this.handleData[0].Status == 0 ? false : true
				} else {
					this.editops = true
				}
				
				this.$emit('onRowClick', val)
			},
			// 删除选中项
			delSelected() {
				if (this.tableflag) {
					var set = this.TableDialogData.map(item => item.ASNGDID)
					var resArr = this.tableDataDis.filter(item => !set.includes(item.ASNGDID))
					this.tableDataDis = resArr
				} else if (this.tableflags) {
					// 唯一码删除（根据唯一码数量加减更改明细）
					// TableDialogUniqueData 选的值 tableDataUnique 唯一码的值 tableDataDis 明细的值
					// //console.log(this.TableDialogUniqueData,"TableDialogUniqueData",this.tableDataDis,"this.tableDataDis",this.tableDataUnique,"tableDataUnique");
					var set = this.TableDialogUniqueData.map(item => item.ID)
					var Batch = this.TableDialogUniqueData.map(item => item.Batch)
					//console.log(Batch, 'Batch');
					for (var i = 0; i < Batch.length; i++) {
						for (var j = 0; j < this.tableDataDis.length; j++) {
							if (Batch[i] == this.tableDataDis[j].Batch) {
								this.tableDataDis[j].Quantity = this.tableDataDis[j].Quantity - 1
								if (this.tableDataDis[j].Quantity <= 0) {
									this.tableDataDis.splice(j, 1)
								}
							}
						}
					}
					var resArr = this.tableDataUnique.filter(item => !set.includes(item.ID))
					this.tableDataUnique = resArr

					// var set = this.TableDialogUniqueData.map(item => item.ASNGDID)
					// var resArr = this.tableDataUnique.filter(item => !set.includes(item.ASNGDID))
					// this.tableDataUnique = resArr
				}
			},
			seve() {
				this.from.Remark = this.$refs.editRd[4].modelvalue
				this.from.InvClass = this.$refs.editRd[2].modelvalue
				this.from.VoucherType = this.$refs.editRd[3].modelvalue
				this.from.VouCode = this.$refs.editRd[0].modelvalue
				if (this.state.length == 2) {
					this.aSNEditUnoq()
				}
				if (this.state.length == 1) {
					this.aSNEditmx()
				}
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {

				this.dialogVisiblesedit = false
			},
			del() {
				if (this.handleData.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.asnDelete()
				this.dialogVisibledel = false
			},
			UNshen() {
				if (this.handleData.length > 0) {
					this.dialogVisibleqUNshen = true
					// console.log(this.$refs.WareHousingRef.$refs.fileTableSelect.clearSelection(),'this.$refs.WareHousingRef');
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});
			},
			cancelqUNshen() {
				this.dialogVisibleqUNshen = false
			},
			dialogOKqUNshen() {
				this.asnUnVerify()
				this.dialogVisibleqUNshen = false
			},
			shen() {
				this.dialogVisibleshen = true
			},
			dialogOKshen() {
				this.dialogVisibleshen = false
			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.handleData.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要审核的数据！'
				});

			},
			dialogOKqshen() {
				this.asnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			tb() {
				this.dialogVisiblestb = true
			},
			canceltb() {
				this.dialogVisiblestb = false
			},
			dialogOKtb() {
				this.dialogVisiblestb = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			GuidanceVideo() {
				this.dialogVisibGuidanceVideo = true
			},
			cancelGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
			dialogOKGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
		},
		watch: {
			dialogVisiblesedit: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						if (this.wtype == 1) {
							//console.log(this.$refs.Ta56, this.$refs.Ta57);
							this.$refs.Ta56.$refs.table56.clearSelection() //监视关闭表格清空选择的表格
						} else if (this.wtype == 0) {
							this.$refs.Ta57.$refs.table57.clearSelection() //监视关闭表格清空选择的表格
						}
					} else {

					}
				},
				deep: true
			},
			dialogVisibGuidanceVideo: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						// 弹窗关闭暂定视频.player.pause()
						console.log(this.$refs.wareVideo.$refs.videoPlayer.pause());
					}
				},
				deep: true
			},
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		margin-top: 10px;
		margin-bottom: 10px;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
	}

	.topstate:nth-child(2) {
		margin-left: 20px;
	}

	.inputtop {
		width: 940px;
		height: 50px;
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		border-top: 1px solid #f0f0f0;
		border-bottom: 1px solid #f0f0f0;
		overflow: hidden;
	}

	.titlefrom {
		width: 120px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		border-left: 3px solid #e71d43;
		font-size: 14px;
		font-weight: bold;
	}
</style>
